import { useEffect } from "react"
import { PointOfCare } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { useReferralStoreContext } from "@/modules/patients/detail/referral/store/useReferralStore"

export const useUpdateReferralState = (pointOfCare: PointOfCare) => {
  const setCareProvider = useReferralStoreContext((state) => state.setCareProvider)

  useEffect(() => {
    if (!pointOfCare) {
      return
    }

    const isSpecialist =
      (pointOfCare.medical === "SPECIALIST" && pointOfCare.actual === null) || pointOfCare.actual === "SPECIALIST"
    const isGeneralPractitioner =
      (pointOfCare.medical === "GENERAL_PRACTITIONER" && pointOfCare.actual === null) ||
      pointOfCare.actual === "GENERAL_PRACTITIONER"

    if (isSpecialist || isGeneralPractitioner) {
      let careProviderId: string | null = null
      if (pointOfCare.__typename === "ch_PointOfCare") {
        careProviderId = pointOfCare.careProvider?.id ?? null
      }
      setCareProvider(careProviderId)
    }
  }, [pointOfCare, setCareProvider])

  return { setCareProvider }
}
